<template name = "dateTemplate" lang="html">
<div class="row">
	  <div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
		 <div class="sidebar-header">
			<h5>Search</h5>
			<a href="" id="sidebarMenuClose"><feather type="x" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
		 </div><!-- df-sidebar-header -->
		 <vueCustomScrollbar>
		 <div class="sidebar-body">
			<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms">
				<li class="nav-label mg-b-10-f" v-if="i === 0">Input Search</li>
				<div class="form-group">
					<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
					<input type="text" v-on:keyup="textKeyupEvent" class="form-control" v-model="form.value" :id="form.id" :placeholder="form.name">
				</div>
			</ul>
			<ul class="sidebar-nav" v-for="(form, i) in inputCompanyForms">
				<li class="nav-label mg-b-10-f" v-if="i === 0">Input Search</li>
				<div class="form-group">
					<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
					<input type="text" v-on:keyup="textKeyupEvent" class="form-control" v-model="form.value" :id="form.id" :placeholder="form.name">
				</div>
			</ul>
			<ul class="sidebar-nav mg-t-35-f" v-for="(form, i) in dateSearchForms">
				<li class="nav-label mg-b-10-f" v-if="i === 0">Date Search</li>
				<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
				<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="form.fvalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="From date" :id="form.fid" aria-label="Search" ignoreReadonly/></li>
				<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="form.evalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="To date" :id="form.eid" aria-label="Search" ignoreReadonly/></li>
			</ul>
			<ul class="sidebar-nav mg-t-35-f" v-for="(form, i) in checkboxSearchForms">
				<li class="nav-label mg-b-10-f" v-if="i === 0">Checkbox Search</li>
				<label for="formGroupExampleInput" class=" d-block">{{form.name}}</label>   
				<div class="custom-control custom-checkbox mg-b-7" :id="form.id" v-for="(form1, i) in form.subs">
					<input type="checkbox" v-on:click="checkClickEvent" class="custom-control-input" :id="form1.codeCode" :value="form1.codeCode">
					<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
				</div> 
			</ul>

         </div><!-- sidebar-body -->
          </vueCustomScrollbar>
      </div><!-- sidebar -->
      <div class="content content-components">
         <div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
               <div>
                  <nav aria-label="breadcrumb">
                     <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                        <li class="breadcrumb-item">{{this.mainName}}</li>
                        <li class="breadcrumb-item active" aria-current="page">{{this.subName}} List</li>
                     </ol>
                     <h4 class="mg-b-0 tx-spacing--1">{{this.subName}} List</h4>
                  </nav>
               </div>
               <!-- <div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
                  <router-link v-if="this.$route.name != 'orderconfirms'" class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" :to="{name:this.$route.name+'_detail', params:{mid:this.properties.mid, type:'detail'}}"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Create</router-link>
               </div> -->
            </div>
            <div class="row row-xs">
               <div class="col-lg-12 mg-t-10">
                    <section>
                        <b-field grouped group-multiline>
                            <b-select v-model="perPage" :disabled="!isPaginated">
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="1000">1000</option>
                            </b-select>
                        </b-field>
                    </section>
                    <section>
                        <b-tabs @change="tabChange" size="is-small">
                            <b-tab-item v-for="(tab, k) in tabNames" :key="k" :label="tab.menuName">
                                <!-- <b-table id="preSampleTable" :columns="preSampleHeader" :data="isEmpty ? [] : preSampleData" :checked-rows.sync="sampleCheckedRows" ref="sampleTable" hoverable striped checkable>
                                    <template slot="empty">
                                        <section class="section">
                                            <div class="content has-text-grey has-text-centered">
                                            <p>Nothing here.</p>
                                            </div>
                                        </section>
                                    </template>
                                </b-table> -->
                                <b-table
                                    :columns="preSampleHeader"
                                    :data="isEmpty ? [] : preDefaultSampleData"
                                    :loading="loading"
                                    paginated
                                    hoverable
                                    striped
                                    backend-pagination
                                    :total="total"
                                    :per-page="perPage"
                                    @page-change="onPageChange"
                                    aria-next-label="Next page"
                                    aria-previous-label="Previous page"
                                    aria-page-label="Page"
                                    aria-current-label="Current page"
                                    backend-sorting
                                    :default-sort="[sortField, sortOrder]"
                                    @sort="onSort"
                                >
                                    <!-- <template slot-scope="props">
                                        <b-table-column 
                                        field="no"
                                        label="No">
                                        {{ props.row.no }}
                                        </b-table-column>
                                        <b-table-column v-for="(form, i) in preSampleHeader"
                                        :key="i"
                                        :field="form.columnCode"
                                        :label="form.columnName"
                                        centered sortable >
                                        {{ props.row[form.columnCode]}}
                                        </b-table-column>
                                    </template> -->
                                    <template slot="empty">
                                        <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>Nothing here.</p>
                                        </div>
                                        </section>
                                    </template>
                                </b-table>
                            </b-tab-item>
                        </b-tabs>
                  </section>
               </div><!-- col -->
            </div><!-- row -->
         </div><!-- container -->
      </div><!-- content -->
   </div>
</template>
<script>
	/* 데이터 테이블 헤더 고정 외부 라이브러리 import */
	//import {floatThead} from '@/lib/floatThead/jquery.floatThead.min.js';
	/* 날짜 입력을 위한 외부 라이브러리 import */
	import datePicker from 'vue-bootstrap-datetimepicker';
	import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import moment from 'moment';
	import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
	import vueCustomScrollbar from 'vue-custom-scrollbar'
	// 공통 스크립트
	import common from "@/views/Common/common.js";
	// Header의 메뉴 정보 호출을 위한 bus event
    import { bus } from "../../main";
    
	export default {
		name: 'List',
		props: ['properties'],
		data(){
			return{
				// date setting
                datePickerOptions: {
                    format: "YYYY-MM-DD",
                    useCurrent: false,
                    showTodayButton: true,
                    keepInvalid: false,
                    ignoreReadonly: true
                },

                menuData: [],
                mid: "",

                // menu name
                mainName: "",
                subName: "",

                // list data
                headers: [],
                data: [],
                isEmpty: false,
                isPaginated: true,
                total: 0,
                loading: false,
                sortField: "",
                sortOrder: "",
                page: 1,
                perPage: 1000,

                // Search data
                inputSearchForms: [],
                dateSearchForms: [],
                checkboxSearchForms: [],
                inputCompanyForms: [],

                //tab name
                tabNames: [],

                ssid: [],
                sampleHeader: [],
                preSampleHeader:[],
                companyId: '',

                preDefaultSampleData: [],
                preDefaultData: [],
			}
        },
        beforeDestroy() {
            bus.$off("menu_data");
            bus.$off("userinfo");
	    },
		created(){
            
		},
		mounted() {
            bus.$on("menu_data", data => {
                this.menuData = data;
                this.classifyTabs();
                // this.classifyHeader();
            });
            bus.$on("userinfo", data => {
                this.official = data.official;
                this.userid = data.id;
            });
		},
		methods: {
            /*
            * keyup search
            */
            textKeyupEvent() {
                this.classifyData();
            },
            dateKeyupEvent(e) {
                if (e.oldDate != null) this.classifyData();
            },
            checkClickEvent(e) {
                this.classifyData();
            },
            async classifyHeader(tabMid) {
                let data = common.menuHeader(this.properties.mid, this.menuData, 1);
                this.mainName = data[0];
                this.subName = data[1];
                let header = common.makeHeader(tabMid, this.menuData, 2);
                this.ssid = header[0];
                this.sampleHeader = header[1];

                let mid = tabMid;
                this.preSampleHeader = [];
                
				for(let i in this.sampleHeader){
                    if(i == 0) this.preSampleHeader.push({'field': 'no', 'label':'No', 'centered':true})//샘플탭 샘플 상세보기에 넘버링 라벨 추가
					if(mid === this.sampleHeader[i].mid) {
                        this.preSampleHeader.push({'field':this.sampleHeader[i].columnCode, 'label':this.sampleHeader[i].columnName, 'centered':true});
                    }else{
                        if(this.sampleHeader[i].columnAttr == 'receptionno')this.preSampleHeader.push({'field':this.sampleHeader[i].columnCode, 'label':this.sampleHeader[i].columnName, 'centered':true,'columnAttr':this.sampleHeader[i].columnAttr})
                    }
					if(common.isNull(this.sampleHeader[i].mid)) this.preSampleHeader.push({'field':this.sampleHeader[i].columnCode, 'label':this.sampleHeader[i].columnName, 'centered':true});
                }
                
            },
            async classifyTabs() {
                await this.$axios.get(this.$apiHost + '/' + this.$route.name + '/tabs')
                .then(res=>{
                    console.log(res.data);
                    let data = common.detailSamples(this.menuData);
                    
                    this.tabNames = res.data;
                    this.tabNames[0].ssid = data[0];
                   
                    this.classifyHeader(this.tabNames[0].menuId)
                    this.classifyData();
                }).catch(err=>{console.log(err)});
            },
            /*
            * Load data
            */
            async classifyData() {
                let params = this.tabNames;
                this.loading = true;
				await this.$axios.get(this.$apiHost + '/' + this.$route.name + '/data', {params})
				.then(res=>{
					for(let i in res.data){
                        this.preDefaultData.push(res.data[i]);
                        for(let j in res.data[i].samples){
                            this.preDefaultSampleData.push(res.data[i].samples[j]);
                        }
                    }
                    for (let i in this.preDefaultSampleData) {
                        this.preDefaultSampleData[i].no = Number(i)+1;
                    }
                    this.loading = false;
                }).catch(err=>{
                    console.log(err)
                    this.loading = false;
                });
                this.preDefaultSampleData = common.makeData_r(this.preDefaultSampleData, 1);
                console.log(this.preDefaultSampleData)
            },
            tabChange(value) {
                this.classifyHeader(this.tabNames[value].menuId)
            },
            /*
            * Handle page-change event
            */
            onPageChange(page) {
                this.page = page;
                this.classifyData();
            },
            /*
            * Handle sort event
            */
            onSort(field, order) {
                this.sortField = field;
                this.sortOrder = order;
                this.classifyData();
            },
		},
		components: {
			datePicker,
            moment,
            vueCustomScrollbar,
		},
		computed: {},
		watch: {
		}
	}
</script>
<style scoped>
	@import '../../assets/css/buefy.css';
</style>


// WEBPACK FOOTER //
// src/views/Sample/List.vue